import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, Youtube, MessageCircle, Stethoscope } from "lucide-react";

export function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10" data-testid="about-page">
      <div className="overline mb-2">About</div>
      <h1 className="font-display font-black text-3xl sm:text-4xl mb-4">Dr. Hariom Choudhary</h1>
      <div className="text-[#5A6D6D] text-sm mb-6">Pediatrician & Neonatologist · Reg. No. RMC34455</div>
      <img src="https://images.pexels.com/photos/5888160/pexels-photo-5888160.jpeg" alt="Dr. Hariom" className="rounded-2xl w-full max-w-md aspect-square object-cover mb-6"/>
      <div className="space-y-4 text-[#232F2F] leading-relaxed">
        <p>Dr. Hariom Choudhary is a qualified Pediatrician & Neonatologist with a passion for making parenting joyful for Indian families. He believes every parent deserves clear, warm, and evidence-based guidance — not fear-inducing medical jargon.</p>
        <p>Through this platform, Dr. Hariom offers teleconsultation across India in both English and Hindi, along with a curated library of e-books, checklists and short videos designed for real Indian homes.</p>
        <p className="font-semibold text-[#2D7A78]">Mission: Make Parenting Joyful.</p>
      </div>
      <Link to="/book" className="btn-primary mt-6" data-testid="about-book-btn"><Stethoscope size={16}/> Book Consultation</Link>
    </div>
  );
}

export function Contact() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10" data-testid="contact-page">
      <div className="overline mb-2">Contact</div>
      <h1 className="font-display font-black text-3xl sm:text-4xl mb-2">Reach Dr. Hariom's team</h1>
      <p className="text-[#5A6D6D] mb-6">We usually respond within a few hours on WhatsApp.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <a href="https://wa.me/916350018891" target="_blank" rel="noreferrer" className="card-soft flex items-center gap-3" data-testid="contact-wa">
          <MessageCircle color="#25D366"/><div><div className="font-semibold">WhatsApp Now</div><div className="text-xs text-[#5A6D6D]">+91 63500 18891</div></div>
        </a>
        <a href="tel:+916350018891" className="card-soft flex items-center gap-3" data-testid="contact-call">
          <Phone color="#2D7A78"/><div><div className="font-semibold">Call</div><div className="text-xs text-[#5A6D6D]">+91 63500 18891</div></div>
        </a>
        <a href="mailto:drhariom09999@gmail.com" className="card-soft flex items-center gap-3" data-testid="contact-email">
          <Mail color="#2D7A78"/><div><div className="font-semibold">Email</div><div className="text-xs text-[#5A6D6D]">drhariom09999@gmail.com</div></div>
        </a>
        <a href="https://www.instagram.com/dr_hariom_pediatrician/" target="_blank" rel="noreferrer" className="card-soft flex items-center gap-3" data-testid="contact-ig">
          <Instagram color="#E4405F"/><div><div className="font-semibold">Instagram</div><div className="text-xs text-[#5A6D6D]">@dr_hariom_pediatrician</div></div>
        </a>
        <a href="https://youtube.com/@drhariompediatrician" target="_blank" rel="noreferrer" className="card-soft flex items-center gap-3" data-testid="contact-yt">
          <Youtube color="#FF0000"/><div><div className="font-semibold">YouTube</div><div className="text-xs text-[#5A6D6D]">@drhariompediatrician</div></div>
        </a>
        <Link to="/book" className="card-soft flex items-center gap-3" data-testid="contact-book">
          <Stethoscope color="#2D7A78"/><div><div className="font-semibold">Book Consultation</div><div className="text-xs text-[#5A6D6D]">Online teleconsult</div></div>
        </Link>
      </div>
      <div className="mt-8 text-xs text-[#5A6D6D] p-4 bg-[#F0F7F7] rounded-xl">
        Medical disclaimer: Content on this platform is for parent education. It does not replace physical consultation when needed. In emergency, visit the nearest hospital immediately.
      </div>
    </div>
  );
}

export function ParentingTips() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10" data-testid="tips-page">
      <div className="overline mb-2">Parenting Tips</div>
      <h1 className="font-display font-black text-3xl sm:text-4xl mb-2">Bite-sized guidance for Indian parents</h1>
      <p className="text-[#5A6D6D] mb-6">Browse our full library of articles, checklists and reels curated by Dr. Hariom.</p>
      <Link to="/content" className="btn-primary" data-testid="tips-explore-btn">Explore all content →</Link>
    </div>
  );
}
